import type { CharityCatalogue } from "@/interfaces/charity";
import { apiClient } from "@/lib/apiClient";

export async function fetchCharityCatalogue(): Promise<CharityCatalogue> {
  const { data } = await apiClient.get<CharityCatalogue>("/charity/causes");
  return { causes: data.causes, defaultSelection: data.defaultSelection ?? [] };
}
